module.exports = require("child-process-promise/lib/ChildProcessPromise");


//////////////////
// WEBPACK FOOTER
// external "child-process-promise/lib/ChildProcessPromise"
// module id = 55
// module chunks = 0